import React, { FC } from 'react'
import { OnIcon, SupportIcon, TerminalIcon } from './Icon'
import { WrapperColor, Wrapper, Title, List, Item } from './styled'

export const AdvantagesPayoutComponent: FC = () => (
	<WrapperColor>
		<Wrapper>
			<Title>Обслуживание и управление</Title>
			<List>
				<Item
					title="Подключение"
					text="Настроим оборудование в точке продаж за 1 час и обучим сотрудников"
				>
					<OnIcon />
				</Item>
				<Item title="Поддержка" text="Ответим на любой вопрос в течение 30 секунд, 24/7">
					<SupportIcon />
				</Item>
				<Item
					title="Замена"
					text="Если терминал сломается, заменим абсолютно бесплатно в течение 24 часов"
				>
					<TerminalIcon />
				</Item>
			</List>
		</Wrapper>
	</WrapperColor>
)
